export const getCheckoutDesktopSelectors = () => {
    return {
        payment: {
            currency_type: 'currency_type',
            payer: {
                // name: '#payer_name',
                first_name: '#payer_first_name',
                last_name: '#payer_last_name',
                email: '#payer_email',
                phonenumber: '#payer_phonenumber',
                area_code: '.iti__selected-dial-code'
            },
            details: {
                cc_number: '#card-number',
                expires: '#card-term',
                cvv: '#cvv',
                card_holder: '#holder',
                country: '#country',
                notes: '#payment_notes'
            }
        },
        confirmBtn: '#confirm-button'
    };
}

/**
 * @todo: Remove mobile dependency.
 * @deprecated
 * @return {{details: {card_holder: string, country: string, expires: string, cvv: string, notes: string, cc_number: string}, payer: {name: string, phonenumber: string, email: string}}}
 */
export const getCheckoutMobilePaymentSelectors = () => {
    return {
        payer: {
            name: '#mobile-payer_name',
            email: '#mobile-payer_email',
            phonenumber: '#mobile-payer_phonenumber'
        },
        details: {
            cc_number: '#mobile-card-number',
            expires: '#mobile-card-term',
            cvv: '#mobile-cvv',
            card_holder: '#mobile-holder',
            country: '#mobile-country',
            notes: '#mobile-payment_notes'
        },
    };
};
